import { RailMessagesDTO, RailStatusesDTO } from "entities/shared/railCard.types";
import { DateTimeModel, SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { ShipmentCardMetadataDTO } from "entities/shared/subscriptionModel";
import { ValueOf } from "shared/lib/typeCheck.lib";

export type LocationDTO = {
  name: string | null;
  state: string | null;
  country: string | null;
  country_code: string | null;
  locode: string | null;
  station_code: string | null;
  railway_zone: string | null;
  division: string | null;
  lat: number | undefined;
  lng: number | undefined;
};

export const TransportTypeDTO = {
  RAIL: "RAIL",
} as const;

export type EventDTO = {
  order_id: number;
  event_code: string | null;
  description: string | null;
  datetime: {
    estimated: DateTimeModel | null;
    actual: DateTimeModel | null;
  };
  location: LocationDTO | null;
  transport_mode: ValueOf<typeof TransportTypeDTO>;
};

export type RouteDTO = {
  order_id: number;
  from: LocationDTO;
  to: LocationDTO;
  transport_mode: ValueOf<typeof TransportTypeDTO>;
  departure_datetime: {
    estimated: DateTimeModel | null;
    actual: DateTimeModel | null;
  };
  arrival_datetime: {
    estimated: DateTimeModel | null;
    actual: DateTimeModel | null;
  };
  path?: unknown[];
};

export type EquipmentDTO = {
  status: ValueOf<typeof RailStatusesDTO>;
  number: string | null;
  wagon_number: string | null;
  train_number: string | null;
  from: LocationDTO | null;
  to: LocationDTO | null;
  departure_datetime: {
    estimated: DateTimeModel | null;
    actual: DateTimeModel | null;
  };
  arrival_datetime: {
    estimated: DateTimeModel | null;
    actual: DateTimeModel | null;
  };
  routes: RouteDTO[];
  events: EventDTO[];
};

export type RailResponseDTO = {
  success: boolean;
  status_code: ValueOf<typeof RailMessagesDTO>;
  metadata: {
    request_parameters: {
      number: SearchReferenceDTO;
      carrier_code: string;
    };
    updated_at: DateTimeModel;
    railway_company: {
      name: string;
      url: string;
      carrier_code: string;
    };
  } & ShipmentCardMetadataDTO;
  data: {
    equipments?: EquipmentDTO[];
  };
};
